import { RouteComponentProps } from "react-router-dom";

export const hasRouteChanged = (
  prevProps: RouteComponentProps,
  nextProps: RouteComponentProps
) => !prevProps || prevProps.location.pathname !== nextProps.location.pathname;
